import { Action, createReducer, on } from '@ngrx/store';
import { ApplicationDomainState } from '../../application-domains.model';
import * as customDomainsActions from './custom-domains.action';

const initialState: ApplicationDomainState = {
  globalSearch: '',
  application_domains: [],
  shuffledColumns: [
    { key: 'Name', field: 'name', hide: false, sort: null, minWidth: 75, width: 155 },
    { key: 'Domains', field: 'domains', hide: false, sort: null, minWidth: 75, width: 85 },
  ],
  pagination: {
    current_page: 1,
    end_at: 0,
    is_first_page: false,
    is_last_page: false,
    next_page: 0,
    prev_page: 0,
    per_page: 10,
    start_at: 0,
    total_count: 0,
    total_pages: 0,
  },
};

const reducer = createReducer(
  initialState,
  on(customDomainsActions.setCustomDomainsList, (state, props) => ({
    ...state,
    application_domains: props.applicationDomainsResponse.application_domains,
    pagination: props.applicationDomainsResponse.pagination,
  })),
  on(customDomainsActions.setCustomDomainsGlobalSearch, (state, props) => ({
    ...state,
    globalSearch: props.globalSearch,
  })),
  on(customDomainsActions.setCustomDomainsCurrentPage, (state, props) => ({
    ...state,
    pagination: {
      ...state.pagination,
      current_page: props.currentPage,
    },
  })),
  on(customDomainsActions.setCustomDomainsShuffledColumns, (state, props) => ({
    ...state,
    shuffledColumns: props.shuffledColumns,
  })),
  on(customDomainsActions.setCustomDomainsColumnSelect, (state, props) => {
    const selectedColumn = state.shuffledColumns.find(
      (column) => column.field === props.columnField
    );
    if (selectedColumn) {
      selectedColumn.hide = false;
    }
    return {
      ...state,
    };
  }),
  on(customDomainsActions.setCustomDomainsColumnSelectall, (state) => ({
    ...state,
    shuffledColumns: state.shuffledColumns.map((column) => {
      return {
        ...column,
        hide: false,
      };
    }),
  })),
  on(customDomainsActions.setCustomDomainsColumnDeselect, (state, props) => {
    const unSelectedColumn = state.shuffledColumns.find(
      (column) => column.field === props.columnField
    );
    if (unSelectedColumn) {
      unSelectedColumn.hide = true;
    }
    return {
      ...state,
    };
  }),
  on(customDomainsActions.setCustomDomainsColumnsSort, (state, props) => {
    state.shuffledColumns.forEach((column) => {
      let fieldMatch = false;
      props.sortedColumns.forEach((data) => {
        if (column.field === data.colId) {
          fieldMatch = true;
          column.sort = data.sort;
        }
      });

      if (!fieldMatch) {
        column.sort = null;
      }
    });
    return { ...state };
  })
);

export function customDomainsReducer(state: ApplicationDomainState | undefined, action: Action) {
  return reducer(state, action);
}
